module.exports = __webpack_public_path__ + "img/006.591d23b4.jpg";